import React, { forwardRef } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { List, ListItem, Button } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import BookmarksIcon from '@material-ui/icons/Bookmarks';
import uuid from 'uuid/v1';


const useStyles = makeStyles(theme => ({
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    color: '#fcfcfc',
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  icon: {
    color: '#fcfcfc',
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  active: {
    color: '#495649',
    fontWeight: theme.typography.fontWeightMedium,
    '& $icon': {
      color: '#495649',
    }
  }
}));

const CustomRouterLink = forwardRef((props, ref) => (
  <div
    ref={ref}
    style={{ flexGrow: 1 }}
  >
    <RouterLink {...props} />
  </div>
));

const SidebarNav = props => {
  const { pages, className, ...rest } = props;
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <List
      {...rest}
    >
      {pages.map(page => (
        <ListItem
          className={classes.item}
          disableGutters
          key={page.title}
        >
          {page.href === '/quickcodes2' ?
            <div style={{ flexGrow: 1 }}>
              <Button
                className={classes.button}
                onClick={handleClick}
              >
                <div className={classes.icon}>{page.icon}</div>
                {page.title}
                {!open ? <ExpandMore style={{ flexGrow: 1 }} /> : <ChevronRightIcon style={{ flexGrow: 1 }} />}
              </Button>
              <Collapse in={!open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {page.submenu ? page.submenu.map(page => (
                    <Button
                      activeClassName={classes.active}
                      className={classes.button}
                      component={CustomRouterLink}
                      to={page.href}
                      key={uuid()}
                    >
                      <div className={classes.icon} style={{ marginLeft: '8px' }}><BookmarksIcon /></div>
                      {page.title}
                    </Button>
                  )) : <div></div>}
                </List>
              </Collapse>
            </div>
            :
            <Button
              activeClassName={classes.active}
              className={classes.button}
              component={CustomRouterLink}
              to={page.href}
            >
              <div className={classes.icon}>{page.icon}</div>
              {page.title}
            </Button>
          }
        </ListItem>
      ))}
    </List>
  );
};

SidebarNav.propTypes = {
  pages: PropTypes.array.isRequired
};

export default SidebarNav;